import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import CustomSidePanel from './common/CustomSidePanel';
import SignatureComponent from './common/SignatureComponent';
import Pagination from './common/Pagination';
import ActionButton from './common/Action Buttons/ActionButton';
import ActionButton2 from './common/Action Buttons/ActionButton2';
import policyTableHeadings from '../data/tableHeadings/contractSigningPolicyTable';
import contractTableHeadings from '../data/tableHeadings/batchContractTableHeadings';

import {TableCell} from './customer/CustomerTableRowComponent';
import LinkTableCellComponent from './common/LinkTableCellComponent';
import SidePanelTableRowComponent from './common/SidePanelTableRowComponent';
import SidePanelTableHeadingComponent from './common/SidePanelTableHeadingComponent';
import ContractsSignPanelHeading from './ContractsSignPanelHeading';
import {putContract, signContracts, SIGN_CONTRACTS} from '../redux/actions/contractsActions';
import {getDurationInMonth} from '../utils';
import {currencyFormatter} from '../utils/formatter';
import {getOrder} from '../api/network/orderService';
import {imeiGenerator} from '../api/dummyGenerators';

import LoadingComponent from './common/LoadingComponent';

const ContainerWrapper = styled.div`
    overflow:hidden;
`;

const PanelContentWrapper = styled.div`
    width: 593px;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin: 40px 0;
`;

const SignatureComponentWrapper = styled.div`
    
`;

const SignatureLabel = styled.div`
    margin: 20px 44px;
    /* text-base/Regular */
    font-family: Metropolis;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/600 */
    color: var(--color-gray-600);
`;

const SelectedCustomersWrapper = styled.div`
    margin: 40px 44px;
    
    /* text-xl/Medium */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    /* default/blue/600 */
    /* default/blue/600 */
    color: var(--color-blue-600);
`;

const PanelActionsWrapper = styled.div`
    width: 593px;
    position: absolute;
    bottom: 0;
    
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 8px;
    
    align-items: center;
    justify-content: space-between;
    padding: 0 44px 32px 44px;
`;

const ActionButtonsWrapper = styled.div`
    display: grid;
    grid-column-gap: 8px;
    grid-auto-flow: column;
`;

const TableWrapper = styled.div`
    overflow: scroll;
    padding: 0 44px 200px 44px;
    
    ::-webkit-scrollbar {
      display: none;
    }
`;

const DevicesTableCell = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 100% */
`;

const SidePanelTableCell = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
`;

const policiesTableGridTemplate = '2400px 240px 40px';
const contractsTableGridTemplate = '120px 100px 140px 200px';

function ContractSignContainer(props) {
    const {
        contracts = [{}],
        showPanel,
        onPanelClose,
        signContracts,
        isSigning,
    } = props;

    const [signatureRef, setSignatureRef] = useState();
    const [policyData, setPolicyData] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const isBatchContracts = (contracts.length > 1);

    useEffect(() => {
        // make call to pull orders for contracts
        if (contracts.length === 1) {
            const contract = contracts.length && contracts[0];

            if (!contract || !contract.orderId) return;
            getOrder(contract.orderId)
                .then(result => {
                    const policyData = {
                        items: [...result[0].items],
                        companyName: contract.companyName,
                        repName: `${contract.representative.firstName} ${contract.representative.lastName}`
                    };

                    if (policyData.items) {
                        const data = [];

                        policyData.items.forEach(item => {
                            for (let i = 0; i < item.quantity; i++) {
                                let id = `P${imeiGenerator().toString()}`;
                                id = id.substring(0, id.length / 2);

                                const obj = {
                                    id,
                                    imei: imeiGenerator().toString(),
                                    serialNumber: imeiGenerator(),
                                    name: policyData.repName,
                                    company: policyData.companyName,
                                    devices: item?.productId.toUpperCase().replace(/-/g, ' ')
                                };

                                data.push(obj);
                            }
                        });
                        setPolicyData(data);
                    }
                })
                .catch(error => console.log(error));
        }

        // create policy dataset
    }, [contracts]);

    useEffect(() => {
        //
        if (isSigning === true) {
            setLoading(true);
        } else if (isSigning === false) {
            setLoading(false);
            onPanelClose();
        }
    }, [isSigning]);

    const setupPoliciesTableRows = policyData => policyData.map(policy => ({
        /**
                     *  NB - the keys for `tableField` should map back to a key from the header data provided.
                     *  NB - The value for should either be a string or a component
                     */
        // policyId: <LinkTableCellComponent
        //     name={policy.id}
        //     onLinkClick={event => event.preventDefault()}
        // />,
        devices: <DevicesTableCell> {policy.devices} </DevicesTableCell>,
        // imei: <TableCell> {policy.imei} </TableCell>,
        serialNumber: <TableCell> {policy.serialNumber} </TableCell>,
        name: <TableCell> {policy.name} </TableCell>,
        company: <TableCell> {policy.company} </TableCell>
    }));
    const setupContractTableRows = contractData => contractData.map(contract => ({
        /**
                     *  NB - the table cell need to have a key because they are going to used in a list.
                     *  NB - the keys for `tableField` should map back to a key from the header data provided.
                     */
        id: contract.contractNumber,
        contractId: <LinkTableCellComponent
            name={contract.contractNumber}
            key={4}
            onLinkClick={event => event.preventDefault()}
        />,
        policies: <LinkTableCellComponent
            name={contract.policies}
            key={5}
            onLinkClick={event => event.preventDefault()}
        />,
        period: <TableCell
            key={2}
        >{getDurationInMonth(contract.startDateOfContract, contract.endDateOFContract)}</TableCell>,
        monthlyPayment: <TableCell key={2}>{currencyFormatter(contract.monthlyPayment)}</TableCell>,
        totalCashPrice: <TableCell key={3}>{currencyFormatter(contract.totalCashPrice)}</TableCell>
    }));

    // TODO get policies for contracts.
    const tableRows = isBatchContracts ? setupContractTableRows(contracts) : setupPoliciesTableRows(policyData);

    console.log('Policy Data', policyData);

    const tableHeadings = isBatchContracts ? contractTableHeadings : policyTableHeadings;
    const tableGridTemplate = isBatchContracts ? contractsTableGridTemplate : policiesTableGridTemplate;

    const onSignatureSave = e => {
        const {disabled} = e.target;

        if (disabled) return;

        signContracts(contracts, signatureRef);
    };

    return (
        <ContainerWrapper>
            <CustomSidePanel open={showPanel} onDrawerClose={onPanelClose}>

                <PanelContentWrapper>
                    {
                        isLoading ? <LoadingComponent/> : (
                            <>
                                <ContractsSignPanelHeading contracts={contracts}/>

                                {/*Signature Component*/}
                                <SignatureComponentWrapper>
                                    <SignatureLabel>Signature </SignatureLabel>

                                    <SignatureComponent
                                        setRef={setSignatureRef}
                                        onSignatureBegin={() => {
                                        }}
                                        onSignatureEnd={() => {
                                        }}
                                    />
                                </SignatureComponentWrapper>

                                {/*Policy Id Table*/}
                                <TableWrapper>

                                    <SidePanelTableHeadingComponent
                                        hasCheckBox={false}
                                        tableHeadings={tableHeadings}
                                        gridTemplate={tableGridTemplate}
                                    />

                                    {
                                        tableRows.map(
                                            (row, index) => (
                                                <SidePanelTableRowComponent
                                                    key={index}
                                                    isSelected={false}
                                                    rowData={row}
                                                    gridTemplate={tableGridTemplate}
                                                    columnHeaders={tableHeadings}
                                                />
                                            )
                                        )
                                    }

                                </TableWrapper>
                            </>
                        )}

                </PanelContentWrapper>

                <PanelActionsWrapper>
                    {
                        // conditionally render pagination component if the user number of rows
                        // are greater than 10;
                        tableRows.length > 10 &&
                        <Pagination
                            page={1}
                            count={1}
                            rowsPerPage={1}
                            onChangePage={() => {
                            }}
                            onRowsPerPageChange={() => {
                            }}
                        />
                    }

                    <ActionButtonsWrapper>
                        <ActionButton onClick={onSignatureSave} disabled={isLoading}>Save</ActionButton>
                        <ActionButton2 onClick={onPanelClose} disabled={isLoading}>Cancel</ActionButton2>
                    </ActionButtonsWrapper>
                </PanelActionsWrapper>

            </CustomSidePanel>
        </ContainerWrapper>
    );
}

ContractSignContainer.propTypes = {contracts: PropTypes.array};

ContractSignContainer.defaultProps = {contracts: {}};

const mapStateToProps = state => {
    const isSigning = state.loading[SIGN_CONTRACTS];
    return {isSigning};
};

const mapDispatchToProps = {
    putContract,
    signContracts
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractSignContainer);
